import { Button, Form, Switch, Spin } from 'antd';
import React, { useEffect } from 'react';
import { HexColorPicker } from "react-colorful";
import BlueTooth from './BluetoothButton';
import { BLUETHOOTH_SERVICE } from '../../Device/Simulator/Bluethooth';

export const SmartBulbConfig = (props) => {
    const [form] = Form.useForm();
    const [state, setState] = React.useState(null);
    const { onClose, masterDevice, device } = props;

    // 发送查询指令到智能灯泡获取当前的状态
    useEffect(() => {
        masterDevice.sendBluetoothCommand(device, BLUETHOOTH_SERVICE.SMART_BULB_QUERY, null, (data) => {
            setState(data);
            form.setFieldsValue(data);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [masterDevice, device]);

    if(!state) {
        return <Spin />
    }

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            margin: '10px'
        }}>
            <Form
                form={form}
                name="basic"
                layout="horizontal"
                labelCol={{ span: 10 }}
                wrapperCol={{ span: 24 }}
                style={{ width: '100%' }}
                initialValues={state}
                onFinish={(values) => {
                    onClose(values);
                }}
            >
                <Form.Item
                    label="开关"
                    name="power"
                    valuePropName="checked"
                    rules={[{ required: false }]}
                >
                    <Switch style={{ display: 'flex' }} />
                </Form.Item>
            
                <Form.Item
                    label="颜色"
                    name="color"
                    rules={[{ required: false }]}
                    valuePropName="color"
                    // shouldUpdate={(prevValues, currentValues) => prevValues.color !== currentValues.color}
                >
                    <HexColorPicker />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">确定</Button>
                </Form.Item>
            </Form>
        </div>
    );
};

function SmartBulb (props) {
    const { device, onClose } = props;

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <BlueTooth device={device} onClose={onClose} />
        </div>
    );
}

export default SmartBulb;